// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkedItemsBlock__i37WT {
  height: 100%;
  position: relative;
}

.emptyLocationsBlock__K3wMr {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: var(--tables-secondary-row-sub-title-surface);
  box-shadow: 0 0 1px rgba(12, 26, 75, 0.24);
}

.emptyLocationsBlockText__PPjo4 {
  color: var(--tables-primary-row-text-additional);
  text-align: center;
  font-family: Roboto;
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
}

.allCheckedItemsWrapper__J_gi0,
.checkedListWrapper__ZxB76 {
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 10px;
  bottom: 0px;
  width: 100%;
}

.checkedListWrapper__ZxB76 {
  top: 45px;
}

.allCheckedItemsBlock__LRLXk,
.checkedList__cm2rg {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  overflow-y: auto;
}
.allCheckedItemsBlock__LRLXk::-webkit-scrollbar,
.checkedList__cm2rg::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 3px;
}
.allCheckedItemsBlock__LRLXk::-webkit-scrollbar-track,
.checkedList__cm2rg::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.allCheckedItemsBlock__LRLXk::-webkit-scrollbar-thumb,
.checkedList__cm2rg::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.allCheckedItemsBlock__LRLXk::-webkit-scrollbar-thumb:hover,
.checkedList__cm2rg::-webkit-scrollbar-thumb:hover {
  background: #888;
  border-radius: 3px;
}

.checkedListInfo__Ml04x {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  margin-top: 12px;
}

.selected__ErEjU {
  color: var(--title-inputs-sections-title);
  font-family: Roboto;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  text-transform: uppercase;
  color: var(--tables-primary-row-text-additional);
}

.clearBtn__eSKPP {
  font-size: 12px;
  line-height: 12px;
  text-transform: uppercase;
  color: var(--buttons-surface);
  cursor: pointer;
}

.chipItemExtra__Eeq4D {
  font-weight: 400;
  color: rgb(168, 172, 183);
  text-transform: capitalize;
  margin-left: 15px;
}`, "",{"version":3,"sources":["webpack://./../src/components/common/FacilityTreeBlock/components/CheckedItemsBlock/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,YAAA;EACA,kBAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,yDAAA;EACA,0CAAA;AAzEF;;AA4EA;EACE,gDAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAzEF;;AA4EA;;EAEE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;AAzEF;;AA4EA;EACE,SAAA;AAzEF;;AA4EA;;EAEE,aAAA;EACA,eAAA;EACA,QAAA;EACA,gBAAA;AAzEF;AApBE;;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AAuBJ;AApBE;;EACE,+BAAA;EACA,kBAAA;AAuBJ;AApBE;;EACE,8BAAA;EACA,kBAAA;AAuBJ;AApBE;;EACE,gBAAA;EACA,kBAAA;AAuBJ;;AAyDA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AAtDF;;AAyDA;EACE,yCAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,gDAAA;AAtDF;;AAyDA;EACE,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,6BAAA;EACA,eAAA;AAtDF;;AAyDA;EACE,gBAAA;EACA,yBAAA;EACA,0BAAA;EACA,iBAAA;AAtDF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.checkedItemsBlock {\n  height: 100%;\n  position: relative;\n}\n\n.emptyLocationsBlock {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  background: var(--tables-secondary-row-sub-title-surface);\n  box-shadow: 0 0 1px rgba(12, 26, 75, 0.24);\n}\n\n.emptyLocationsBlockText {\n  color: var(--tables-primary-row-text-additional);\n  text-align: center;\n  font-family: Roboto;\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 14px;\n}\n\n.allCheckedItemsWrapper,\n.checkedListWrapper {\n  display: flex;\n  flex-direction: column;\n  position: absolute;\n  top: 10px;\n  bottom: 0px;\n  width: 100%;\n}\n\n.checkedListWrapper {\n  top: 45px;\n}\n\n.allCheckedItemsBlock,\n.checkedList {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  overflow-y: auto;\n\n  @include scrollBar;\n}\n\n.checkedListInfo {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 15px;\n  margin-top: 12px;\n}\n\n.selected {\n  color: var(--title-inputs-sections-title);\n  font-family: Roboto;\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 14px;\n  text-transform: uppercase;\n  color: var(--tables-primary-row-text-additional);\n}\n\n.clearBtn {\n  font-size: 12px;\n  line-height: 12px;\n  text-transform: uppercase;\n  color: var(--buttons-surface);\n  cursor: pointer;\n}\n\n.chipItemExtra {\n  font-weight: 400;\n  color: rgb(168, 172, 183);\n  text-transform: capitalize;\n  margin-left: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"checkedItemsBlock": `checkedItemsBlock__i37WT`,
	"emptyLocationsBlock": `emptyLocationsBlock__K3wMr`,
	"emptyLocationsBlockText": `emptyLocationsBlockText__PPjo4`,
	"allCheckedItemsWrapper": `allCheckedItemsWrapper__J_gi0`,
	"checkedListWrapper": `checkedListWrapper__ZxB76`,
	"allCheckedItemsBlock": `allCheckedItemsBlock__LRLXk`,
	"checkedList": `checkedList__cm2rg`,
	"checkedListInfo": `checkedListInfo__Ml04x`,
	"selected": `selected__ErEjU`,
	"clearBtn": `clearBtn__eSKPP`,
	"chipItemExtra": `chipItemExtra__Eeq4D`
};
module.exports = ___CSS_LOADER_EXPORT___;
